import Container from 'react-bootstrap/Container';
import styles from "../../styles/contcatus.module.scss";
import { Row } from 'react-bootstrap';
import ManagersSlider from '../ManagerCards';

const CountryTeam = ({ countryTeamData }: { countryTeamData: any }) => {
    return (
        <div id="country-team" className={`${styles.officeCountries}`} style={{ backgroundColor: '#FFE7C9' }}>
            <Container>
                {countryTeamData?.regionalManagers && (
                    <div id='reg-manag' className={styles.regionalManagers}>
                        <Container>
                            <Row className='text-center'>
                                <div>
                                    <h2>Connect with our {countryTeamData?.countryName} Team</h2>
                                </div>
                            </Row>
                            <Row id='regional-managers'>
                                {countryTeamData.regionalManagers.managerCard?.length > 0 && (
                                    <ManagersSlider
                                        data={countryTeamData.regionalManagers.managerCard}
                                    />
                                )}
                            </Row>
                        </Container>
                    </div>
                )}
                {countryTeamData?.countrySalesManagers && (
                    <div className={styles.regionalSalesManagers} style={{ backgroundColor: '#FFE7C9' }}>
                        <Container>
                            <Row className="text-center">
                                <div>
                                    <h2>{countryTeamData.countrySalesManagers.title}</h2>
                                </div>
                            </Row>
                            <Row>
                                {countryTeamData.countrySalesManagers.managerCard?.length > 0 &&
                                    <ManagersSlider data={countryTeamData.countrySalesManagers.managerCard} />}
                            </Row>
                        </Container>
                    </div>
                )}
            </Container>
        </div>
    )
}

export default CountryTeam;